import { Route } from '@/app/router'

const ReturningOrderOem = () => import('./index.vue')

export default new Route('/returning-orders-oem/:id', ReturningOrderOem).as('Dashboard:ReturningOrderOem').permissions(['VIEW_ORDER'])
